import { useTranslation } from "react-i18next";
import { BookmarkPlus } from "lucide-react";

/**
 * How many times something in the catalogue was added to somebody's own
 * library: the quiet half of "this works", beside the likes.
 */
export default function CopyCount({ count }: { count?: number }) {
    const { t } = useTranslation();
    if (!count) return null;
    const label = t("meditation.copies.count", { count });
    return (
        <span className="flex items-center gap-1 text-xs text-content-tertiary" title={label}>
            <BookmarkPlus size={13} aria-hidden="true" />
            <span className="tabular-nums" aria-hidden="true">
                {count}
            </span>
            <span className="sr-only">{label}</span>
        </span>
    );
}
